

export default function getDomain() {
    var domain = "https://api.gatesweeney.com:5556"
    if (window.location.hostname === "localhost") { domain = "http://localhost:80" }

    return domain
}